export const saveUserToStorage = (user) => {
  try {
    if (!user || typeof user !== 'object') return;

    // Creamos una copia del usuario añadiendo explícitamente el role
    const userToStore = {
      ...user,
      role: user.isAdmin ? 'admin' : 'user',
    };

    localStorage.setItem('user', JSON.stringify(userToStore));

    if (user.token) {
      localStorage.setItem('token', user.token);
    } else {
      localStorage.removeItem('token');
    }
  } catch (error) {
    console.error('Error guardando usuario en localStorage:', error);
  }
};

export const getTokenFromStorage = () => {
  try {
    return localStorage.getItem('token');
  } catch (error) {
    console.error('Error al leer token de localStorage:', error);
    return null;
  }
};

export const getUserFromStorage = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error al leer usuario de localStorage:', error);
    return null;
  }
};

export const getPerfilFromStorage = () => {
  try {
    const perfil = JSON.parse(localStorage.getItem('perfilActual'));
    if (perfil && perfil.id) {
      return perfil;
    }
    return null;
  } catch (error) {
    console.error('Error al leer perfil de localStorage:', error);
    return null;
  }
};

export const clearUserStorage = () => {
  try {
    localStorage.removeItem('user');
    localStorage.removeItem('perfilActual');
    localStorage.removeItem('perfilActivoId');
  } catch (error) {
    console.error('Error al limpiar localStorage:', error);
  }
};

export const savePerfilToStorage = (perfil, userId) => {
  try {
    if (!perfil?.id) {
      console.error('Intento de guardar perfil sin ID:', perfil);
      return false;
    }
    
    const perfilData = {
      id: perfil.id,
      nombre: perfil.nombre,
      es_admin: perfil.es_admin || false,
      avatar: perfil.avatar || 'default.png',
      user_id: perfil.user_id || userId, // 👈 ESTA LÍNEA ES CLAVE
    };
    
    localStorage.setItem('perfilActual', JSON.stringify(perfilData));
    localStorage.setItem('perfilActivoId', perfil.id);
    return true;
  } catch (error) {
    console.error('Error al guardar perfil:', error);
    return false;
  }
};
